var _excluded = ["disabled", "edges", "showError", "errorMessage", "fullWidth", "helperText", "helperTextPlacement", "icon", "label", "required", "variant", "format", "value", "placeholder", "onChange", "name"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@mui/material/InputAdornment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EventIcon from '@mui/icons-material/Event';
import { LocalizationProvider, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import TextInput from './TextInput';
import IconButton from './IconButton';
import { StyledWrapper } from './DatePicker.styled';
var DatePicker = function DatePicker(_ref) {
  var disabled = _ref.disabled,
    edges = _ref.edges,
    showError = _ref.showError,
    errorMessage = _ref.errorMessage,
    fullWidth = _ref.fullWidth,
    helperText = _ref.helperText,
    helperTextPlacement = _ref.helperTextPlacement,
    icon = _ref.icon,
    label = _ref.label,
    required = _ref.required,
    variant = _ref.variant,
    format = _ref.format,
    value = _ref.value,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    name = _ref.name,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    required: required,
    hasValue: !!value
  }, /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, /*#__PURE__*/React.createElement(MuiDatePicker, _extends({
    open: open,
    clearable: true,
    disableCloseOnSelect: false,
    inputFormat: format,
    value: value,
    onChange: onChange,
    views: ['day'],
    onClose: function onClose() {
      return setOpen(false);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextInput, _extends({}, params, {
        onClick: function onClick() {
          return setOpen(true);
        },
        name: name,
        fullWidth: fullWidth,
        label: label,
        helperText: helperText,
        helperTextPlacement: helperTextPlacement,
        disabled: disabled,
        required: required,
        showError: showError,
        errorMessage: errorMessage,
        edges: edges,
        variant: variant,
        autoComplete: "off",
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(IconButton, {
            onClick: function onClick() {
              return setOpen(true);
            }
          }, icon || /*#__PURE__*/React.createElement(EventIcon, null)))
        }
      }));
    }
  }, rest))));
};
DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.string,
  /**
   * Input icon
   */
  icon: PropTypes.node,
  /**
   * Placed the helper text above or below the input.
   */
  helperTextPlacement: PropTypes.oneOf(['above', 'below']),
  /**
   * The label content.
   */
  label: PropTypes.string,
  /**
   * The field name.
   */
  name: PropTypes.string.isRequired,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined']),
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * Date format. See: https://day.js.org/docs/en/display/format
   */
  format: PropTypes.string,
  /**
   * if true., will use the KeyboardDatePicker component https://material-ui-pickers.dev/api/KeyboardDatePicker
   */
  keyboard: PropTypes.bool,
  /**
   * Handle Input change event
   */
  onChange: PropTypes.func
} : {};
DatePicker.defaultProps = {
  disabled: false,
  edges: 'normal',
  error: false,
  fullWidth: false,
  helperText: '',
  icon: undefined,
  helperTextPlacement: 'above',
  label: '',
  placeholder: 'DD/MM/YYYY',
  required: false,
  value: undefined,
  variant: 'outlined',
  showError: false,
  errorMessage: '',
  format: 'dd/MM/yyyy',
  keyboard: true,
  onChange: null
};
export default DatePicker;